"use client"
import { useEffect } from "react"

declare global {
  interface Window {
    __lc?: any
    LiveChatWidget?: any
  }
}

export default function Livechat() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.__lc = window.__lc || {}
      window.__lc.license = 18728040
      window.__lc.integration_name = "manual_onboarding"
      window.__lc.product_name = "livechat"

      ;(function (n: Window, t: Document) {
        function i(n: any) {
          return e._h ? e._h.apply(null, n) : e._q.push(n)
        }

        var e = {
          _q: [] as any[],
          _h: null as ((...args: any[]) => any) | null,
          _v: "2.0",
          on: function (...args: any[]) {
            i(["on", args])
          },
          once: function (...args: any[]) {
            i(["once", args])
          },
          off: function (...args: any[]) {
            i(["off", args])
          },
          get: function (...args: any[]) {
            if (!e._h) {
              throw new Error(
                "[LiveChatWidget] You can't use getters before load."
              )
            }
            return i(["get", args])
          },
          call: function (...args: any[]) {
            i(["call", args])
          },
          init: function () {
            const script = t.createElement("script")
            script.async = true
            script.type = "text/javascript"
            script.src = "https://cdn.livechatinc.com/tracking.js"
            t.head.appendChild(script)
          },
        }

        if (!n.__lc.asyncInit) {
          e.init()
        }
        n.LiveChatWidget = n.LiveChatWidget || e
      })(window, document)
    }
  }, [])

  return (
    <noscript>
      <a href="https://www.livechat.com/chat-with/18728040/" rel="nofollow">
        Chat with us
      </a>
      , powered by{" "}
      <a
        href="https://www.livechat.com/?welcome"
        rel="noopener nofollow"
        target="_blank"
      >
        LiveChat
      </a>
    </noscript>
  )
}
